import { format, formatDistanceToNowStrict, isValid, parseISO } from 'date-fns';

const asDate = (value: string | Date | null | undefined) => {
  if (!value) return null;
  // Date-only columns arrive as "2026-10-19" or "2026-10-19T00:00:00.000Z": read them as that
  // calendar day locally, so they don't shift a day for users west of UTC.
  const dateOnly = typeof value === 'string' ? /^(\d{4}-\d{2}-\d{2})(T00:00:00(\.000)?Z)?$/.exec(value) : null;
  const d = typeof value === 'string' ? parseISO(dateOnly ? dateOnly[1]! : value) : value;
  return isValid(d) ? d : null;
};

/** 19 Oct 2026 */
export const formatDate = (value: string | Date | null | undefined) => {
  const d = asDate(value);
  return d ? format(d, 'd MMM yyyy') : '—';
};

/** 19 Oct 2026, 14:05 */
export const formatDateTime = (value: string | Date | null | undefined) => {
  const d = asDate(value);
  return d ? format(d, 'd MMM yyyy, HH:mm') : '—';
};

/** "3 hours ago" / "in 2 days" */
export const formatRelative = (value: string | Date | null | undefined) => {
  const d = asDate(value);
  if (!d) return '—';
  const s = formatDistanceToNowStrict(d, { addSuffix: true });
  return s;
};

/** YYYY-MM-DD for <input type="date"> */
export const toInputDate = (value: string | Date | null | undefined) => {
  const d = asDate(value);
  return d ? format(d, 'yyyy-MM-dd') : '';
};

export function formatMoney(amount: string | number | null | undefined, currency = 'GBP') {
  if (amount === null || amount === undefined || amount === '') return '—';
  const n = typeof amount === 'string' ? Number(amount) : amount;
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(n);
}

export const pluralize = (n: number, word: string, plural = `${word}s`) => `${n} ${n === 1 ? word : plural}`;

export const initials = (name: string | null | undefined) =>
  (name ?? '?')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('') || '?';

export const fullName = (p: { firstName: string; lastName?: string | null }) => `${p.firstName} ${p.lastName ?? ''}`.trim();
